import React, { useState, useEffect } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useAuth } from "@/contexts/AuthContext";

export default function AccommodationPopup() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Only show to logged-in users who are athletes (or if they don't have a specific type, assume athlete by default as it's the main user base)
    if (user && (!user.participant_type || user.participant_type === "Athlete")) {
      const storageKey = `hasSeenAccomPopup_${user.id}`;
      const hasSeen = localStorage.getItem(storageKey);
      
      if (!hasSeen) {
        // slight delay to not abruptly show it before the rest of dashboard paints
        const timer = setTimeout(() => {
          setOpen(true);
        }, 500);
        return () => clearTimeout(timer);
      }
    }
  }, [user]);

  const handleClose = () => {
    setOpen(false);
    if (user) {
      localStorage.setItem(`hasSeenAccomPopup_${user.id}`, "true");
    }
  };

  return (
    <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) handleClose(); }}>
      <DialogContent className="sm:max-w-md p-0 overflow-hidden bg-transparent border-none shadow-none flex justify-center">
        <div className="relative w-full max-w-sm rounded-xl overflow-hidden group">
          <img 
            src="/images/accommodation-manager.jpg" 
            alt="Accommodation Manager" 
            className="w-full h-auto object-cover"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
